import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../CSS/style.css";


const ScheduleA1 = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let checkTheme = document.getElementById("root");
    if(checkTheme.classList.contains("dark-mode")){
      checkTheme.classList.remove('dark-mode');
    }
  });

  // useEffect(() => {
  //   // Load remembered email from local storage
  //   const themeColor = localStorage.getItem('themeColor');
  //   console.log("Inside Dark Mode")
  //   //const rememberedPassword=localStorage.getItem('rememberedPassword');
  //   if (themeColor==='light_mode') {
  //     console.log("Inside Dark Mode")
  //     document.body.classList.add('dark-mode');
  //   }
  //   else{
  //     document.body.classList.remove('dark-mode');
  //   }
  // }, []);

  return (
    <section class="bg-white">
    <div class="container eulaDocMain">
      <div class="row headerLogo">
        <div class="col">
        <div class="eulaDocCopilotDiv" id="chat-header">
              <img
                src="Img/cimatron-logo-720x177.png"
                alt="Cimatron-logo"
                className="img-fluid d-block eulaDocLogo"
              /> <div class="vr"></div> <img
                src="Img/copilot-icon-text-bubble-black-512.png"
                alt="copilot-icon-text-bubble-white"
                className="eulaDocCopilot-icon" id="copilot-icon"
              /> <h3 class="px-2">Cimatron Copilot</h3>
            </div>
        </div>
      </div>
      <div class="row eula-content">
        <div class="col">
          <div class="pb-2">
            <h1>Schedule A.1 to End-User License Agreement </h1>
            <hr />
          </div>
          <div class="pb-2">
            <h3>Data Processing Agreement</h3>
            <p>PARTIES:</p>
            <p>
              This data processing agreement is made on [19 - 08 - 2024]
              between:
            </p>
            <ol className="braces">
              <li>
                <p>
                  CIMATRON LTD , reg. no. [520042672], a company incorporated
                  under the laws of Israel;{" "}
                </p>
                <div class="row dpa-table mb-2">
                  <div class="col-lg-4">
                    <p>
                      <strong>Address</strong>
                    </p>
                    <p>
                      Cimatron Ltd 9 Hapsagot Street, <br />
                      Petach-Tikva 4951041
                      <br />
                      Israel Park Ofer East,
                      <br /> C building, 5th Floor
                    </p>
                  </div>
                  <div class="col-lg-4">
                    <p>
                      <strong>Contact person</strong>
                    </p>
                    <p>Dan Marinac</p>
                  </div>
                  <div class="col-lg-4">
                    <p>
                      <strong>E-mail</strong>
                    </p>
                    <p>
                      <a href="mailto:dan.marinac@cambrio.com">
                        dan.marinac@cambrio.com
                      </a>
                    </p>
                  </div>
                </div>
                <p>and, on the other hand, </p>
              </li>
              <li>
                the End User, End-User or YOU (from now on the “End-User”), as
                further specified in the End-User License Agreement between
                Cimatron and the End-User, (each a "Party" and together the
                "Parties").{" "}
                <p>
                  By submitting an online subscription order, the End-User
                  accepts this DPA as an integral part of the Master Agreement.
                </p>
                <p>
                  For the End-User’s details, including contact details to
                  contact person of the End-User,{" "}
                  <a href="/end-user-license-agreement">
                    see the Master Agreement between the Parties.
                  </a>
                </p>
              </li>
            </ol>
            <h3>BACKGROUND AND UNDERTAKINGS</h3>
            <hr />
            <p>The Parties agree the following:</p>
            <ol type="A">
              <li>
                The Parties have entered into a into an End-User License
                Agreement regarding the CIMATRON SOFTWARE including also a BETA
                version of the cloud based feature CIMATRON AI COPILOT (the
                "Master Agreement") under which Cimatron will provide certain
                services (the "Services") to the End-User. Within the scope of
                the Master Agreement, Cimatron will (as a processor) process
                personal data on behalf of the End-User (as a controller), as
                detailed in the Instructions in Schedule 1 of this DPA. This DPA
                constitutes a schedule to the Master Agreement and forms an
                integral part of the Master Agreement.
              </li>
              <li>
                Within the scope of this DPA, the End-User is, as applicable:
                (a) the controller of the End-User's personal data which
                Cimatron processes as a processor on behalf of the End-User; or
                (b) has been instructed by and obtained the authorization of the
                relevant End-User Affiliate(s) to agree to the processing of
                personal data by Cimatron as set out in this DPA, meaning that
                the End-User and the relevant End-User Affiliates are the
                controllers of the personal data which Cimatron processes as a
                processor on behalf of the End-User and the relevant End-User
                Affiliates; or (iii) together with any End-User Affiliate that
                has entered into applicable scope of works/order forms with
                Cimatron, which outlines the content, scope and purposes of the
                Services that Cimatron shall provide to the End-User and the
                relevant End-User Affiliate, are the controllers of the
                personal data which Cimatron processes as a processor on behalf
                of the End-User and the relevant End-User Affiliate. For the
                avoidance of doubt, the applicable scope of work/order form
                shall constitute a separate agreement between the End-User
                Affiliate and the Cimatron entity party to the scope of
                work/order form. Accordingly, breach of the scope of the
                work/order form by either party shall not constitute a breach of
                this DPA and likewise, a breach of this DPA by any party shall
                not constitute a breach of the scope of work/order form.
              </li>
              <li>
                Cimatron determines the purposes and means of certain data
                processing of the End-User’s personal data, such as when we are
                developing and improving the CIMATRON AI COPILOT or in order to
                provide statistics and Cimatron is the controller for such
                processing and is, consequently, solely responsible for the
                lawfulness of such processing as controller under Applicable
                Data Protection Laws.{" "}
              </li>
              <li>
                This DPA regulates transfers of personal data from Cimatron and
                its Affiliates located both outside of and inside of the EU/EEA
                to the End-User located within the EU/EEA.
              </li>
              <li>
                [To the extent Applicable Data Protection Laws applies, this DPA
                also regulates transfers of per-sonal data from Cimatron and its
                Affiliates to End-User located outside the EU/EEA, provided that
                the End-User, including the processing of personal data carried
                out by the End-User under this DPA, is subject to a binding
                adequacy decision issued by the EU Commission in accordance with
                Article 45 of the GDPR. If such adequacy decision of whatever
                reason no longer is valid or applicable in relation to the
                End-User and/or the processing of personal data under this DPA,
                the Parties shall, in addition to this DPA, automatically be
                bound by the Model Clauses in its relevant parts.]
              </li>
              <li>
                Where any provision of this DPA requires the Parties to notify
                or otherwise communicate with each other, such notification or
                communication shall be made to the email addresses specified in
                this preamble of the DPA above, unless otherwise agreed in
                writing by relevant employees of the Parties.
              </li>
              <li>
                Notwithstanding any priority clauses in the Master Agreement and
                with regard to the subject matter of this DPA, in the event of
                inconsistencies between the provisions of this DPA and the
                Master Agreement, the provisions of this DPA shall prevail with
                regard to the Parties’ data protection obligations. In the
                event of any conflict or inconsistency between the provisions
                below and the Model Clauses (where such Model Clauses are
                applicable), the terms of the Model Clauses shall apply in
                accordance with Clause [5] of the Model Clauses.{" "}
              </li>
            </ol>
            <h3>INTRODUCTION</h3>
            <hr />
            <ol>
              <li>
                <p>
                  <strong>Definitions</strong>
                </p>
                <p>
                  Lower case terms used but not defined in this DPA, such as
                  "controller", "processor", "personal data", "processing" and
                  "personal data" shall have the same meaning as in Article 4 of
                  the GDPR. Additional definitions used in this DPA are outlined
                  below.{" "}
                </p>
              </li>
            </ol>
            <h3>OBLIGATIONS OF THE PARTIES</h3>
            <hr />
            <ol type="1" start="2">
              <li>
                <p>
                  <strong>Instructions </strong>
                </p>
                <ol class="list-style-none">
                  <li>
                    2.1 &nbsp; Cimatron shall only process personal data on
                    behalf of the End-User in accordance with the Instructions
                    by the End-User and Applicable Data Protection Laws.
                  </li>
                  <li>
                    2.2 &nbsp; Cimatron shall only process personal data on
                    behalf of the End-User in accordance with the Instructions
                    by the End-User and Applicable Data Protection Laws.
                  </li>
                  <li>
                    2.3 &nbsp; If Cimatron notifies the End-User that an
                    additional instruction is not feasible or the End-User
                    notifies Cimatron that it does not accept the quote for the
                    additional Instruction, the End-User shall terminate its use
                    of CIMATRON AI COPILOT without any liability for Cimatron.{" "}
                  </li>
                </ol>
              </li>
            </ol>
            <ol type="1" start="3">
              <li>
                <p>
                  <strong>
                    Technical and organisational security measures{" "}
                  </strong>
                </p>
                <ol class="list-style-none">
                  <li>
                    3.1 &nbsp; Cimatron will provide and maintain appropriate
                    technical and organizational security measures for the
                    processing of End-User’s personal data, which measures are
                    intended to protect such personal data against accidental
                    or unauthorized loss, destruction, alteration, disclosure or
                    access, and to ensure a level of security appropriate to the
                    particular risks involved in the processing. In this
                    connection, the parties agree that:
                  </li>
                  <ol class="list-style-none">
                    <li>
                      3.1.1 &nbsp; further details on the technical and
                      organizational security measures that will be implemented
                      and maintained by Cimatron in processing the personal data
                      are described or referred to in Schedule 2; and{" "}
                    </li>
                    <li>
                      3.1.2 &nbsp; the technical and organizational measures
                      will be subject to technical progress, development and
                      improvements for the protection of personal data.
                      Accordingly, Cimatron reserves the right to modify such
                      measures provided that Cimatron continues to ensure a
                      level of security appropriate to the particular risks
                      involved in the processing.
                    </li>
                  </ol>
                  <li>
                    3.2 &nbsp; In the processing of the End-User’s personal
                    data, Cimatron: (i) will only rely on personnel who are
                    contractually or by statutory obligation bound to maintain
                    confidentiality; and (ii) ensure that access to personal
                    data processed is limited to those personnel who require
                    such access to perform the Services.
                  </li>
                </ol>
              </li>
            </ol>
            <ol type="1" start="4">
              <li>
                <strong>Documentation and compliance</strong>{" "}
              </li>
              <ol class="list-style-none">
                <li>
                  4.1 &nbsp; Upon request, Cimatron shall provide the End-User
                  with documentation reasonably necessary to demonstrate
                  compliance with Applicable Data Protection Laws.
                </li>
                <li>
                  4.2 &nbsp; The End-User may conduct an inspection or audit of
                  the technical and organizational measures that Cimatron has
                  implemented to fulfil its obligations under this DPA and
                  Cimatron will provide such other information as possible to
                  demonstrate compliance with article 28 of the GDPR provided
                  that: (i) the documentation in section above cannot reasonably
                  demonstrate compliance with Applicable Data Protection Laws;
                  or (ii) a competent supervisory authority requires inspection
                  of Cimatron. The End-User shall notify Cimatron sixty (60)
                  days in advance prior to conducting such inspection.{" "}
                </li>
                <li>
                  4.3 &nbsp; For the avoidance of doubt, an inspection or audit
                  carried out in accordance with this section 4 shall only
                  comprise such information that is strictly necessary in order
                  for the End-User to determine whether Cimatron takes
                  appropriate technical and organizational measures to fulfil
                  its obligations under this DPA and shall under no
                  circumstances comprise any other information e.g. regarding
                  Cimatron’s business operations, other End-Users of Cimatron or
                  intellectual property, which is not relevant to Cimatron’s
                  processing of personal data on behalf of the End-User under
                  this DPA.{" "}
                </li>
                <li>
                  4.4 &nbsp; The Parties acknowledge and agree that any onsite
                  inspection must be conducted by a thirdparty auditor jointly
                  appointed by both Parties. The End-User shall ensure that such
                  third party undertakes confidentiality in relation to any
                  information that the third party receives within the scope of
                  the inspection, such confidentiality undertaking being not
                  less restrictive than the confidentiality undertaking in
                  section 10 below. Further, the inspection must occur during
                  normal business hours and only in a manner that causes
                  minimal disruption to Cimatron’s business. The End-User shall
                  be liable for any breach of such confidentiality undertaking
                  by the third party. Any and all costs and expenses related to
                  the inspection shall be borne by the End-User, including any
                  potential costs and expenses incurred by Cimatron due to
                  Cimatron’s participation in such inspection.
                </li>
              </ol>
            </ol>
            <ol type="1" start="5">
              <li>
                <strong>Use of sub-processors</strong>{" "}
              </li>
              <ol class="list-style-none">
                <li>
                  5.1 &nbsp; The End-User hereby gives Cimatron a general
                  written authorization to engage sub-processors to process
                  personal data on behalf of the End-User. Cimatron shall ensure
                  the sub-processor has entered into a data processing agreement
                  with obligations no less restrictive than those set out in
                  this DPA. Cimatron shall be liable for the acts and omissions
                  of any Sub-Processor to the same extent as if the acts or
                  omissions were performed by Cimatron.{" "}
                </li>
                <li>
                  5.2 &nbsp; All sub-processors engaged by Cimatron as of the
                  Effective Date are provided in Schedule 1 of this DPA.
                  Cimatron will provide End-User with notification of any new
                  Sub-processor before authorizing such new Sub-processor to
                  process the personal data, at least thirty (30) days in
                  advance of such change. Cimatron shall provide the End-User
                  with a process to obtain notice of any new or changed
                  sub-processors. The notification to the End-User shall
                  include the same information of a new or changed
                  sub-processor as set out in Schedule 1 of this DPA regarding
                  currently engaged sub-processors.
                </li>
                <li>
                  5.3 &nbsp; The End-User may object to the addition or
                  replacement of a sub-processor provided that such objection is
                  reasonable and based on data protection grounds. If Cimatron
                  is unable to accommodate the End-User’s objection, the
                  End-User may terminate its use of CIMATRON AI COPILOT without
                  any liability for Cimatron by notifying Cimatron.
                </li>
                <li>
                  5.4 &nbsp; Where the End-User does not object to the change
                  within thirty (30) days of the notice by Cimatron, Cimatron
                  may engage the sub-processor for the processing of personal
                  data on behalf of the End-User.
                </li>
              </ol>
            </ol>
            <ol type="1" start="6">
              <li>
                <strong>International Transfers</strong>
                <p></p>
                <p>
                  The processing activites under the Master Agreement will
                  involve a transfers of personal data within the meaning of
                  Chapter V of the GDPR.
                </p>
                <p>
                  [The Parties acknowledge that the European Commission has
                  recognized Israel as providing an adequate level of data
                  protection pursuant to Article 45 of the General Data
                  Protection Regulation (GDPR). Accordingly, the transfer of
                  personal data from an End-User within the European Economic
                  Area (EEA) to Cimatron in Israel is permitted without the need
                  for additional safeguards.]{" "}
                </p>
                <p>
                  The End-User agrees that where Cimatron either itself, via an
                  Affiliate or by engaging a sub-processor for specific
                  processing activities (on behalf of the End-User) that involve
                  a transfer of personal data within the meaning of Chapter V of
                  the GDPR, Cimatron and the sub-processor can ensure compliance
                  with the GDPR, for example by using standard contractual
                  clauses adopted by the Commission in accordance with Article
                  46(2) of the GDPR, provided the conditions for the use of
                  those standard contractual clauses are met .
                </p>
              </li>
            </ol>
            <ol type="1" start={7}>
              <li>
                <strong>Cooperation and assistance </strong>
              </li>
              <ol class="list-style-none">
                <li>
                  7.1 &nbsp; Cimatron will report to the End-User without undue
                  delay any request received by Cimatron from a competent
                  supervisory authority or a data subject relating to the
                  processing of personal data under this DPA.{" "}
                </li>
                <li>
                  7.2 &nbsp; Taking into account the nature of the processing,
                  Cimatron will assist the End-User in complying with its
                  obligation to respond to requests of data subjects under
                  Applicable Data Protection Laws, by appropriate technical and
                  organizational measures provided that the information is
                  available to Cimatron, and such information is not otherwise
                  available to the End-User.{" "}
                </li>
                <li>
                  7.3 &nbsp; The End-User acknowledges that Cimatron has no
                  responsibility to interact directly with any data subject or
                  supervisory authority in respect of any request, demand or
                  order (except as expressly provided under Applicable Data
                  Protection Laws) or as otherwise agreed by the Parties in
                  writing.{" "}
                </li>
                <li>
                  7.4 &nbsp; Cimatron shall, upon the End-User's request and
                  taking into account the nature of the processing and the
                  information available to Cimatron, provide information to the
                  End-User in order to allow the End-User to fulfil its legal
                  obligations to carry out data protection impact assessments
                  (DPIAs) and prior consultations with the relevant supervisory
                  authority under Applicable Data Protection Laws in relation to
                  the processing of personal data covered by the Services.
                </li>
                <li>
                  7.5 &nbsp; Cimatron shall have a right to reasonable
                  compensation for any assistance provided to the End-User
                  pursuant to this Section 7, or otherwise as according to a
                  separate agreement between the Parties.
                </li>
              </ol>
            </ol>
            <ol type="1" start={8}>
              <li>
                <strong>Notification of personal data breach </strong>
              </li>
              <ol class="list-style-none">
                <li>
                  8.1 &nbsp; In the event of a personal data breach involving
                  personal data processed on behalf of the End-User and subject
                  to this DPA, Cimatron shall notify the End-User, in writing
                  without undue delay, after becoming aware of the personal data
                  breach.{" "}
                </li>
                <li>
                  8.2 &nbsp; Taking into account the nature of processing and
                  the information available to Cimatron, Cimatron shall assist
                  the End-User in fulfilling its responsibilities under Articles
                  33 and 34 of the GDPR by doing the following:
                  <ol class="list-style-none">
                    <li>
                      8.2.1 &nbsp; Cimatron will investigate the personal data
                      breach and take reasonable measures to identify its root
                      cause(s) and, where such breach is caused by Cimatron or a
                      Cimatron sub-processor, take steps to prevent a
                      recurrence;
                    </li>
                    <li>
                      8.2.2 &nbsp; As information is collected or otherwise
                      becomes available, to the extent legally permitted,
                      Cimatron will provide the End-User with a description of
                      the personal data breach, the type of the personal data to
                      which the breach relates, and, other information the
                      End-User may reasonably request concerning the affected
                      data subject(s) where such information is available to
                      Cimatron.
                    </li>
                  </ol>
                </li>
                <li>
                  8.3 &nbsp; The Parties agree to coordinate in good faith on
                  developing the content of any related public statements or any
                  required notices to the affected data subjects.
                </li>
                <li>
                  8.4 &nbsp; To the extent that a personal data breach is caused
                  by the End-User, a End-User Affiliate or anyone acting for
                  the End-User, Cimatron will inform the End-User of the
                  personal data breach and provide information it discovers up
                  to the stage it identifies the breach is caused by the
                  End-User, a End-User Affiliate or anyone acting for the
                  End-User. Further assistance to investigate such a personal
                  data breach is subject to the prior agreement of the Parties.
                </li>
              </ol>
            </ol>
            <ol type="1" start={9}>
              <li>
                <strong>Request from a competent supervisory authority </strong>
              </li>
              <p>
                In case a competent supervisory authority or other regulator
                requests:{" "}
              </p>
              <ol type="a" className="braceswithletter">
                <li>
                  information from Cimatron regarding the processing of personal
                  data under this DPA; or
                </li>
                <li>
                  that Cimatron shall disclose personal data processed on behalf
                  of the End-User under this DPA,
                </li>
              </ol>
              <p>
                Cimatron shall, without undue delay, notify the End-User of any
                requests in accordance with this Section 9. The Parties shall
                thereafter consult regarding the competent supervisory
                authority's request. This obligation does not apply if Cimatron
                is prohibited under applicable law to notify or consult with the
                End-User regarding the supervisory authority's request. Cimatron
                may not act on the End-User's behalf as agent for the End-User
                or otherwise.{" "}
              </p>
            </ol>
            <h3>FINAL PROVISIONS</h3>
            <hr />
            <ol type="1" start="10">
              <li>
                <strong>Confidentiality</strong>
                <p></p>
                <p>
                  Without any prejudice to any confidentiality undertaking
                  included in the Master Agreement, the Parties agree to keep
                  the contents of this DPA confidential, unless a Party is
                  legally obligated to disclose its contents.
                </p>
              </li>
            </ol>
            <ol type="1" start="11">
              <li>
                <strong>Term and termination</strong>
                <p></p>
                <p>
                  This DPA is effective during the same term as the Master
                  Agreement and for such additional period that Cimatron
                  processes personal data on behalf of the End-User.
                </p>
              </li>
            </ol>
            <ol type="1" start="12">
              <li>
                <strong>Return of personal data</strong>
                <p></p>
                <p>
                  Upon termination of the Master Agreement, Cimatron shall
                  delete or anonymize the personal data that Cimatron processes
                  on behalf of the End-User or, upon the End-User’s written
                  request, return such personal data to the End-User, unless
                  Cimatron is legally obligated to continue to store the
                  personal data. If the End-User does not provide any
                  instruction within thirty (30) days following the termination
                  of the Master Agreement or the DPA, the personal data shall be
                  deleted or anonymized by Cimatron without undue delay.
                </p>
              </li>
            </ol>
            <ol type="1" start="13">
              <li>
                <strong>Survival of certain terms </strong>
                <p></p>
                <p>
                  Section 10 (Confidentiality), section 12 (Return of personal
                  data), section 14 (Liability), section 15 (Severability),
                  section 16 (No waiver), section 18 (Governing law), and
                  section 19 (Disputes) shall survive the termination of this
                  DPA for any reason.
                </p>
              </li>
            </ol>
            <ol type="1" start="14">
              <li>
                <strong>Liability </strong>
              </li>
              <ol className="list-style-none">
                <li>
                  14.1 &nbsp; Each Party shall be liable for any administrative
                  fines by a competent supervisory authority imposed on the
                  Party in question due to the Party's failure to fulfil its
                  obligations under this DPA or Applicable Data Protection Laws.
                </li>
                <li>
                  14.2 &nbsp; Liability for any claims for damages from data
                  subjects concerned shall be governed by Article 82 of the
                  GDPR. All other indirect, consequential, special or incidental
                  cost, loss or damage of any kind are excluded.
                </li>
                <li>
                  14.3 &nbsp; Notwithstanding what is stated above, Cimatron’s
                  total liability for any administrative fines, damages or
                  other direct, indirect, consequential or incidental cost, loss
                  or damage of any kind caused by breach of this DPA shall be
                  limited to the amount paid by the End-User to Cimatron.{" "}
                </li>
              </ol>
            </ol>
            <ol type="1" start="15">
              <li>
                <strong>Severability</strong>
                <p></p>
                <p>
                  If any provision of this DPA is or becomes invalid, illegal or
                  unenforceable under applicable law, the validity, legality and
                  enforceability of the remainder of the DPA shall not be
                  affected. Instead, the deficient provision shall be replaced
                  with a new provision permitted by applicable law and having an
                  effect as close as possible to the deficient provision.
                </p>
              </li>
            </ol>
            <ol type="1" start="16">
              <li>
                <strong>No waiver</strong>
                <p></p>
                <p>
                  Delay by either Party to exercise a right or remedy under this
                  DPA shall not affect such Party's right to enforce such right
                  or remedy at a later time. A waiver by a Party of any breach
                  of a provision under this DPA shall not be construed to be a
                  waiver by such Party in relation to subsequent breaches of
                  such or other provisions in this DPA.
                </p>
              </li>
            </ol>
            <ol type="1" start="17">
              <li>
                <strong>Changes</strong>
                <p></p>
                <p>
                  If changes to Applicable Data Protection Laws or if binding
                  judgements or the Services are changed in such a way which
                  requires amendments to this DPA, Cimatron has a unliteral
                  right to make necessary updates to this DPA by notifying the
                  End-User in advance of such changes. If the End-User has not
                  objected in writing to such proposed changes within thirty
                  (30) days from when the notification was sent by Cimatron, the
                  Parties agree that the proposed changes to the DPA shall enter
                  into force with immediate effect. For the avoidance of doubt,
                  this Section 17 does not apply to changes regarding
                  sub-processors as such changes are governed by Section 5.
                </p>
              </li>
            </ol>
            <ol type="1" start="18">
              <li>
                <strong>Governing law</strong>
                <p></p>
                <p>
                  This DPA is governed by [Swedish law], without giving effect
                  to any principles of conflicts of law.
                </p>
              </li>
            </ol>
            <ol type="1" start="19">
              <li>
                <strong>Disputes</strong>
                <p></p>
                <p>
                  Any dispute controversy or claim arising out of or in
                  connection with this DPA, or the breach, termination or
                  invalidity thereof shall be settled in accordance with the
                  dispute resolution clause included in the Master Agreement,
                  unless the Parties agree otherwise.
                </p>
              </li>
            </ol>
            <h3>ADDITIONAL DEFINITIONS</h3>
            <hr />
            <p>The following additional defined terms are used in this DPA:</p>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Term</th>
                    <th scope="col">Meaning</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="25%">"Applicable Data Protection Laws"</td>
                    <td>
                      means all applicable data privacy laws and regulations of
                      the EEA, including all of its member states and
                      regulations issued by the relevant supervisory
                      authorities;
                    </td>
                  </tr>
                  <tr>
                    <td>"End-User Affiliate"</td>
                    <td>
                      means any entity which is controlled by End-User, which
                      controls End-User, or which is under common control with
                      End-User. For the purpose of this DPA, “control” of an
                      entity means the direct or indirect ownership of more than
                      fifty per cent (50%) of the shares or interests entitled
                      to vote for the directors of such entity or equivalent
                      power over the management of such entity, for so long as
                      such entitlement or power exists;
                    </td>
                  </tr>
                  <tr>
                    <td>"GDPR"</td>
                    <td>
                      means Regulation (EU) 2016/679 of the European Parliament
                      and of the Council of 27 April 2016 on the protection of
                      natural persons with regard to the processing of personal
                      data and on the free movement of such data, and repealing
                      Directive 95/46/EC (General Data Protection Regulation);
                    </td>
                  </tr>
                  <tr>
                    <td>"Instructions" </td>
                    <td>
                      means (i) the relevant terms and conditions of this DPA
                      and the Master Agreement; and (ii) any further documented
                      instructions that the End-User may from time to time give,
                      provided they relate to and are consistent with the
                      Services provided by Cimatron under the Master Agreement
                      and DPA, including Schedule 1 of this DPA;
                    </td>
                  </tr>
                  <tr>
                    <td>"Model Clauses"</td>
                    <td>
                      [means the EU Commission's implementing decision (EU)
                      2021/914 of 4 June 2021 applicable to
                      processor to controller transfers (Module 4);]
                    </td>
                  </tr>
                  <tr>
                    <td>"Services"</td>
                    <td>
                      means services offered to the End-User by Cimatron as
                      described in the Master Agreement.{" "}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
};

export default ScheduleA1;
